import {FileContainerReq} from '@yasc/yasc-material-components';
import {TicketTypeEnum} from '../../../enums';

export class AgentInfoReq {
    userAgent: string;
    platform: string;
    screenResolution: string;
    minMemory: string | number;
    cpuCores: string | number;

    constructor() {
        this.userAgent = navigator.userAgent;
        this.platform = navigator.platform;
        this.screenResolution = `${window.screen.width}x${window.screen.height}`;
        this.minMemory = (navigator as any).deviceMemory || 'Unknown';
        this.cpuCores = (navigator as any).hardwareConcurrency || 'Unknown';
    }
}

export class BugCreateReq {
    route!: string;
    title!: string;
    description!: string;
    stepsToReproduce: string[] = [];
    attachments: FileContainerReq[] = [];
    ticketType: TicketTypeEnum = TicketTypeEnum.ticketTypeBug;
    agentInfo?: AgentInfoReq
}

export class BugCreateRes {
    ticketNumber!: string;
    ticketLink!: string;
}